module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', [(!_vm.data.success) ? _c('div', {
    staticClass: "pass-reset-page"
  }, [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Ustaw nowe hasło")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("\n      Wpisz w poniższym polu nowe hasło,"), _c('br'), _vm._v("\n      którym chcesz się logować do Twojego panelu.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "email-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("Twoje nowe hasło:")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.data.errors['message'].join(', ')))]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("Wystąpił nieoczekiwany błąd aplikacji")])]) : _vm._e(), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "password",
      "name": "password",
      "label": "Nowe hasło",
      "required": "true",
      "errors": _vm.data.errors['password']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['password'] = val; }
    },
    model: {
      value: (_vm.data.password),
      callback: function($$v) {
        _vm.$set(_vm.data, "password", $$v)
      },
      expression: "data.password"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "label": "Powtórz hasło",
      "required": "true",
      "errors": _vm.data.errors['password_confirmation']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['password_confirmation'] = val; }
    },
    model: {
      value: (_vm.data.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.data, "password_confirmation", $$v)
      },
      expression: "data.password_confirmation"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-large z-depth-0",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Zapisz nowe hasło")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli nadal potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])]), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3200787b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/passReset.vue
// module id = 368
// module chunks = 0